<template>
  <v-toolbar
    :color="mobile ? 'primary' : null"
    :flat="!mobile"
    app
    fixed>
    <v-toolbar-side-icon
      @click.stop="$emit('input', !value)"
      class="white--text" v-if="mobile" />
    <v-spacer></v-spacer>
    <calendar
      v-show="!isHome"
      v-if="settingsLoaded" />
    <v-spacer></v-spacer>
    <v-menu
      v-model="menuLocali"
      v-if="settings && settings.locali.length > 0"
      :close-on-content-click="false"
      offset-y>
      <template v-slot:activator="{ on }">
        <v-btn :color="mobile ? 'white' : 'info'" dark flat icon v-on="on">
          <v-icon>mdi-format-list-checks</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-tile
            color="primary"
            :key="index"
            v-for="(locale, index) in settings.locali">
            <v-list-tile-avatar>
              <v-btn @click="toggleLocaleLocal(locale.id)" ripple icon color="primary">
                <v-icon>
                  {{ localiAttiviLocal.includes(locale.id) ?
                    'mdi-eye' :
                    'mdi-eye-off' }}</v-icon>
              </v-btn>
            </v-list-tile-avatar>
            <v-list-tile-content >
              <span class="headline">{{ locale.nome }}</span>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>
    <template v-if="!mobile">
      <v-btn to="profilo" flat icon color="green">
        <v-icon>mdi-account</v-icon>
      </v-btn>
      <v-btn @click="logout" flat icon color="red">
        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>
    </template>
    <v-menu v-else offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" flat icon color="white">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile to="profilo">
          <v-list-tile-action>
            <v-icon color="green">mdi-account</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Profilo</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="logout">
          <v-list-tile-action>
            <v-icon color="red">mdi-exit-to-app</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Logout</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
import Calendar from '@/components/Calendar.vue';
import ld from 'lodash';

export default {
  name: 'top-menu',
  props: {
    value: Boolean,
  },
  components: { Calendar },
  data() {
    return {
      menuLocali: false,
      localiAttiviLocal: [],
    };
  },
  watch: {
    menuLocali(newV, oldV) {
      if (oldV && !newV) {
        ld.xor(this.localiAttiviLocal, this.localiAttivi)
          .forEach(locale => this.toggleLocale(locale));
      } else {
        this.localiAttiviLocal = [...this.localiAttivi];
      }
    },
  },
  methods: {
    toggleLocaleLocal(locale) {
      const localiAttivi = ld.xor(this.localiAttiviLocal, [locale]);
      if (localiAttivi.length > 0) {
        this.localiAttiviLocal = localiAttivi;
      }
    },
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    isHome() {
      return this.$route.path === '/';
    },
  },
};
</script>

<style lang="stylus" scoped>
.v-toolbar.elevation-0
  background-color #fafafa
</style>
